import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import { fromEvent } from 'rxjs';

@Directive({selector: '[offClick]'})

export class OffClickDirective implements OnInit, OnDestroy {

    @Input() offClickExcluded: Array<string>;

    @Output()
    offClick: EventEmitter<Event> = new EventEmitter<Event>();

    private subscription: Subscription;
    private documentBodyElement: HTMLElement;
    private baseElement: HTMLElement;

    private i = 0;

    constructor(private el: ElementRef) {

        this.baseElement         = this.el.nativeElement;
        this.documentBodyElement = document.body;

    }

    ngOnInit() {

        this.subscription = fromEvent(document, 'click').subscribe((event: Event) => {
            this.clickHandler(event.srcElement, event);
        });

    }

    private clickHandler(currentElement: HTMLElement | Element, event: Event): void {

        if (currentElement === this.documentBodyElement || currentElement == null) {

            for (const excluded of this.offClickExcluded) {
                if (event.srcElement.classList.contains(excluded)) {
                    return;
                }
            }

            // Skip first click event

            if (this.i > 0) {
                this.offClick.emit(event);
            }

            this.i++;

            return;
        }

        if (currentElement === this.baseElement) {
            return;
        }

        this.clickHandler(currentElement.parentElement, event);

    }


    ngOnDestroy() {

        this.subscription.unsubscribe();

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/directives/off-click.directive.ts